import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";
import Leadership from "./widget/leadership";


const Leader = () => {
  return (
    <>
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Leadership"} />
        <Leadership />
        {/* FooterOne */}
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Leader;
